module.exports = __webpack_public_path__ + "static/media/marketo2x.4207ca21.png";